/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */

/** @author John Hann */

/**
 * Create a deep copy of x which must be a legal JSON object/array/value
 * @param {object|array|string|number|null} x object/array/value to clone
 * @returns {object|array|string|number|null} clone of x
 */
export function clone(x:any):any
{
    if( x == null || typeof x !== 'object' )
        return x;

    if( Array.isArray(x) )
        return cloneArray(x);

    return cloneObject(x);
}

function cloneArray<T>(x:Array<T>):Array<T>
{
    const l:number = x.length;
    const y:Array<T> = new Array(l);

    for( let i:number = 0; i < l; ++i )
        y[i] = clone(x[i]);

    return y;
}

function cloneObject<T>(x:T):T
{
    const keys:Array<string> = Object.keys(x);
    const y:T = {} as any;

    for( let k:string, i:number = 0, l = keys.length; i < l; ++i )
    {
        k = keys[i];
        y[k] = clone(x[k]);
    }

    return y;
}

export interface SegmentsTree
{
    [key:string]:SegmentsTree;
}

export function shallowClone(x:any, segmentsTree:SegmentsTree):any
{
    if( x == null || typeof x !== 'object' )
        return x;

    if( Array.isArray(x) )
        return shallowCloneArray(x, segmentsTree);

    return shallowCloneObject(x, segmentsTree);
}

function shallowCloneArray<T>(x:Array<T>, segmentsTree:SegmentsTree):Array<T>
{
    if( !segmentsTree || Object.keys(segmentsTree).length === 0 )
        return x;

    const l:number = x.length;
    const y:Array<T> = new Array(l);

    for( let i:number = 0; i < l; ++i )
        if( segmentsTree[i] )
            y[i] = shallowClone(x[i], segmentsTree[i]);
        else
            y[i] = x[i];

    return y;
}

function shallowCloneObject<T>(x:T, segmentsTree:SegmentsTree):T
{
    if( !segmentsTree || Object.keys(segmentsTree).length === 0 )
        return x;

    const keys:Array<string> = Object.keys(x);
    const y:T = {} as any;

    for( let k:string, i:number = 0, l = keys.length; i < l; ++i )
    {
        k = keys[i];

        if( segmentsTree[k] )
            y[k] = shallowClone(x[k], segmentsTree[k]);
        else
            y[k] = x[k];
    }

    return y;
}
